import IFaturaConcessionaria from "../interfaces/IFaturaConcessionaria";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class FaturaConcessionariaService {
    async get(id: string) {
        return await api.get<IFaturaConcessionaria>(`${resources.faturaConcessionaria}/GetById/${id}`);
    }

    async create(data: IFaturaConcessionaria) {
        return await api.post<IFaturaConcessionaria>(`${resources.faturaConcessionaria}/Create`, data);
    }

    async update(data: IFaturaConcessionaria) {
        return await api.put<any>(`${resources.faturaConcessionaria}/Update`, data);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.faturaConcessionaria}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async discard(id: any) {
        return await api.put<any>(`${resources.faturaConcessionaria}/Discard/${id}`);
    }

    async charge(data: any) {
        return await api.post<IFaturaConcessionaria>(`${resources.faturaConcessionaria}/Charge`, data);
    }

    async chargeXml(data: any) {
        return await api.post<IFaturaConcessionaria>(`${resources.faturaConcessionaria}/ChargeXml`, data);
    }

    async chargeCsv(data: any) {
        return await api.post<IFaturaConcessionaria>(`${resources.faturaConcessionaria}/ChargeCsv`, data);
    }
}

export default new FaturaConcessionariaService();
